var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.05 3.555C0.150818 3.11324 0.398655 2.71881 0.752922 2.43631C1.10719 2.1538 1.54688 1.99997 2 2H14C14.4531 1.99997 14.8928 2.1538 15.2471 2.43631C15.6013 2.71881 15.8492 3.11324 15.95 3.555L8 8.414L0.05 3.555ZM0 4.697V11.801L5.803 8.243L0 4.697ZM6.761 8.83L0.191 12.857C0.353327 13.1993 0.609527 13.4884 0.929782 13.6908C1.25004 13.8931 1.62117 14.0004 2 14H14C14.3788 14.0001 14.7498 13.8926 15.0698 13.6901C15.3899 13.4876 15.6459 13.1983 15.808 12.856L9.238 8.829L8 9.586L6.761 8.83ZM10.197 8.244L16 11.801V4.697L10.197 8.244Z",
    fill: "#003738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.55e1920f88dc3238f60085a833f23da8.svg";
export { ForwardRef as ReactComponent };